module.exports = __webpack_public_path__ + "static/media/download.d1bd3cf5.svg";